import * as Yup from "yup";
import { errors } from "shared/constants/errors";

export const PASSWORD_POLICY_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

export const buildPasswordValidation = (translate) =>
  Yup.string()
    .required(translate(errors.CANNOT_BE_EMPTY))
    .matches(
      PASSWORD_POLICY_REGEX,
      translate("VALIDATION.PASSWORD_REQUIREMENTS")
    );